<template>
  <div>{{ project.name }}</div>
</template>

<script>
export default {
  props: ["project"]
};
</script>

<style scoped></style>
